import promise from 'redux-promise';
import { combineReducers, applyMiddleware, createStore } from 'redux';
import baseReducer from './utils/baseReducer';
import glosaReducer from './pages/glosas/reducer';

const rootReducer = combineReducers({
  base: baseReducer,
  glosa: glosaReducer,
});

// eslint-disable-next-line no-underscore-dangle
const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = applyMiddleware(promise)(createStore)(rootReducer, devTools);

export default store;



// WEBPACK FOOTER //
// ./src/reducers.js